import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _Init;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import KNB from '@dp/knb';
import UA from './ua';
import User from './user';
import Geo from './geo';
import Env from './env';
import Util from './utils';
import Url from './utils/url';
import Platform from './platform';
import redirect from './utils/redirect';
import Cookie from './utils/cookie';
import Store from './store';
import Event from './event';
import activityTag from './config/activityTag';
window.__DripTest = {
  UA: UA,
  User: User,
  Geo: Geo,
  Env: Env,
  Util: Util,
  Url: Url,
  Platform: Platform,
  redirect: redirect,
  Cookie: Cookie,
  Store: Store,
  activityTag: activityTag
};
var _eventListenr = Symbol('eventListenr');
var _allReady = Symbol('AllReady');
var _readyArray = Symbol('readyArray');
var _readyPending = Symbol('readyPending');
function reload() {
  if (UA.isNative) {
    redirect(location.href, {
      jump: true
    });
  } else {
    window.location.reload();
  }
}
function throttle(cb) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var shouldWait = false;
  return function () {
    if (shouldWait) return;
    cb.apply(void 0, arguments);
    shouldWait = true;
    setTimeout(function () {
      shouldWait = false;
    }, delay);
  };
}
function importScript(sSrc) {
  return new Promise(function (resolve) {
    var oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.onerror = function () {
      resolve(false);
    };
    oScript.onload = function () {
      resolve(true);
    };
    document.currentScript.parentNode.insertBefore(oScript, document.currentScript);
    oScript.src = sSrc;
  });
}
var getType = function getType(context) {
  return Object.prototype.toString.call(context).slice(8, -1);
};
var appFlag = function () {
  var flags = {
    myFlag: ['maoyan'],
    mtFlag: ['meituan'],
    dpFlag: ['dianping'],
    wxFlag: ['dianping_chwl', 'maoyan_wechat'],
    myWxFlag: ['maoyan_wechat']
  };
  var data = {};
  var appName = UA.appName;
  for (var k in flags) {
    data[k] = flags[k].indexOf(appName) !== -1;
  }
  data['webFlag'] = !UA.isNative;
  return data;
}();
var shareTag;
if (appFlag.dpFlag) {
  shareTag = 'dpshare';
} else if (appFlag.mtFlag) {
  shareTag = 'mtshare';
} else if (appFlag.myFlag) {
  shareTag = 'myshare';
} else {
  shareTag = 'share';
}

// 设置bizname
KNB.config({
  bizname: 'maoyan_show'
});
// 需要兼容项目老代码 ，暂时这样赋值, 减少业务代码影响

var constant = Object.assign({
  search: Url.parse().query || {},
  cookies: Cookie.getAll(),
  uaInfo: UA,
  ajaxUrl: Platform.ajaxUrl,
  ajaxBetaUrl: Platform.ajaxBetaUrl,
  Env: Env,
  shareTag: shareTag,
  appType: Platform.sellChannel,
  sellChannel: Platform.sellChannel
}, appFlag);
var Init = (_Init = {
  UA: UA,
  User: User,
  putRegular: function putRegular(k, v) {
    var dp = '.dianping.com';
    var dpBeta = '.51ping.com';
    v = Env.isProduct ? v.replace(dpBeta, dp) : v.replace(dp, dpBeta);
    constant[k] = v;
  }
}, _defineProperty(_Init, _allReady, false), _defineProperty(_Init, _readyArray, []), _defineProperty(_Init, _readyPending, false), _defineProperty(_Init, "constant", constant), _defineProperty(_Init, "loadScript", Util.loadScript), _defineProperty(_Init, "login", throttle(User.login.bind(User), 1500)), _defineProperty(_Init, "logout", User.logout.bind(User)), _defineProperty(_Init, "reload", reload), _defineProperty(_Init, "redirect", redirect), _defineProperty(_Init, "getUuid", User.getUuid.bind(User)), _defineProperty(_Init, "getFingerprint", User.getFingerprint.bind(User)), _defineProperty(_Init, "setStore", Store.set.bind(Store)), _defineProperty(_Init, "getStore", Store.get.bind(Store)), _defineProperty(_Init, "removeStore", Store.remove.bind(Store)), _defineProperty(_Init, "activityTag", activityTag), _defineProperty(_Init, "Env", Env), _defineProperty(_Init, "ready", function ready() {
  var _arguments = arguments,
    _this = this;
  return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var task, shouldGetLocation, allReady, readyType, _data, initTask, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          task = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
          shouldGetLocation = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
          allReady = _this[_allReady];
          readyType = getType(allReady); // 回调方式添加至数组
          getType(task) === 'Function' && _this[_readyArray].push(task);
          if (UA.IS_DouyinShowMicroApp) {
            // 抖音演出小程序加载js sdk
            importScript('https://lf3-cdn-tos.bytegoofy.com/obj/goofy/developer/jssdk/jssdk-1.2.1.js');
          }

          // 已完成Ready直接返回
          if (!(readyType === 'Object')) {
            _context.next = 9;
            break;
          }
          _this[_readyArray].forEach(function (x) {
            return x.call(x);
          });
          return _context.abrupt("return", allReady);
        case 9:
          if (!_this[_readyPending]) {
            _context.next = 16;
            break;
          }
          if (!(readyType === 'Promise')) {
            _context.next = 15;
            break;
          }
          _context.next = 13;
          return allReady;
        case 13:
          _data = _context.sent;
          return _context.abrupt("return", _data);
        case 15:
          return _context.abrupt("return");
        case 16:
          // 加载中
          _this[_readyPending] = true;
          initTask = [Geo.getCity(), shouldGetLocation ? Geo.getLocation() : Promise.resolve({
            lng: 0,
            lat: 0
          }), User.getUserInfo()];
          if (!Platform.preInit) {
            _context.next = 21;
            break;
          }
          _context.next = 21;
          return Platform.preInit();
        case 21:
          _this[_allReady] = Promise.all(initTask).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
              city = _ref2[0],
              location = _ref2[1],
              user = _ref2[2];
            Init.constant = Object.assign(Init.constant, Object.assign({}, city, location, user));
            return Init.constant;
          }).catch(function (e) {
            return console.log(e);
          });
          _context.next = 24;
          return _this[_allReady];
        case 24:
          data = _context.sent;
          _this[_readyPending] = false;
          _this[_allReady] = data;
          _this[_eventListenr]();

          // 兼容老代码 回调函数方式
          _this[_readyArray].forEach(function (x) {
            return x();
          });
          _this[_readyArray] = [];
          return _context.abrupt("return", data);
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))();
}), _defineProperty(_Init, _eventListenr, function () {
  var _ = Object.assign;
  Event.on('cityChange', function (res) {
    _(Init.constant, Object.assign({}, res));
  });
  Event.on('locationChange', function (res) {
    _(Init.constant, Object.assign({}, res));
  });
  Event.on('tokenChange', function (res) {
    _(Init.constant, {
      token: res
    });
  });
}), _defineProperty(_Init, "setTitle", function setTitle(title) {
  title = title || document.title;
  UA.isNative ? KNB.setTitle({
    title: title
  }) : document.title = title;
}), _Init);
!window.Drip && (window.Drip = Init);
export default Init;